import React from 'react';
import { Divider, Paper } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';
import { makeStyles } from '@material-ui/styles';
import { isUndefined } from 'lodash';
import PropTypes from 'prop-types';

const useStyles = makeStyles(theme => ({
  infoPaper: {
    marginRight: '1em',
    padding: '1em',
    textAlign: 'center',
    minWidth: '200px',
  },
  title: {
    textTransform: 'uppercase',
    fontWeight: 700,
  },
  titleSkeleton: {
    width: '80%',
    margin: 'auto',
  },
  divider: {
    backgroundColor: theme.palette.secondary.main,
    height: 2,
    width: '20%',
    margin: `${theme.spacing()}px auto`,
  },
  body: {
    fontFamily: theme.typography.mainFont,
    fontSize: '1.125em',
  },
  bodySkeleton: {
    width: '50%',
    margin: 'auto',
  },
}));

const InfoCard = ({ title, body }) => {
  const classes = useStyles();

  return (
    <Paper className={classes.infoPaper}>
      {title && !isUndefined(body) ? (
        <small className={classes.title}>{title}</small>
      ) : (
        <Skeleton className={classes.titleSkeleton} variant="text" />
      )}
      <Divider className={classes.divider} />
      {!isUndefined(body) ? (
        <p className={classes.body}>{body || '-'}</p>
      ) : (
        <Skeleton className={classes.bodySkeleton} variant="text" />
      )}
    </Paper>
  );
};

InfoCard.propTypes = {
  title: PropTypes.string.isRequired,
  body: PropTypes.any.isRequired,
};

export default InfoCard;
